// extracted by mini-css-extract-plugin
export default {"productGrid":"r2-z","centerLink":"s2-z","productSection":"t2-z","item":"u2-z","ctaButton":"v2-z"};